import { render, staticRenderFns } from "./UserLocationForm.vue?vue&type=template&id=563a3fea&"
import script from "./UserLocationForm.vue?vue&type=script&lang=js&"
export * from "./UserLocationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports